import { LoanApplicationTabId } from 'app/pages/loanApplication/LoanApplication.constants';
import { CUSTOM_FIELDS_TARGET } from 'app/shared/components/customFields/CustomFieldsSection/CustomFieldsSection.constants';

import {
  getBorrowersAssetsAction,
  getBorrowersIncomesAction,
  getBorrowersLiabilitiesAction,
  getBorrowersReoAction,
  updateAssetsAction,
  updateIncomesAction,
  updateLiabilitiesAction,
  updateReoAction,
} from 'store/loanApplications/actions';

import { FINANCIAL_INFO_VIEWS_PATHS } from '../../FinancialInfo.constants';
import { SUMMARY_CARDS_NAMES } from '../../FinancialInfoHead/FinancialInfoHead.config';

import Assets from './SectionContent/Assets';
import {
  normalizeAssetsDataToSend,
  normalizeAssetsPendingChanges,
  normalizeAssetsReceivedData,
} from './SectionContent/Assets/Assets.utils';
import EmploymentAndIncome from './SectionContent/EmploymentAndIncome';
import {
  normalizeIncomesDataToSend,
  normalizeIncomesPendingChanges,
  normalizeReceivedIncomesData,
} from './SectionContent/EmploymentAndIncome/EmploymentAndIncome.utils';
import Liabilities from './SectionContent/Liabilities';
import {
  normalizeLiabilitiesDataToSend,
  normalizeLiabilitiesPendingChanges,
  normalizeLiabilitiesReceivedData,
} from './SectionContent/Liabilities/Liabilities.utils';
import Reo from './SectionContent/Reo';
import {
  normalizeReceivedReoData,
  normalizeReoDataToSend,
  normalizeReoPendingChanges,
} from './SectionContent/Reo/Reo.utils';

export const TITLE_DATA = {
  [FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT]: {
    title: 'Income',
    summaryCardsNames: [SUMMARY_CARDS_NAMES.TOTAL_INCOME],
    addButtonText: 'Employment/Income',
  },
  [FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES]: {
    title: 'Liabilities',
    summaryCardsNames: [SUMMARY_CARDS_NAMES.TOTAL_LIABILITIES],
    addButtonText: 'Liability',
  },
  [FINANCIAL_INFO_VIEWS_PATHS.ASSETS]: {
    title: 'Assets',
    summaryCardsNames: [SUMMARY_CARDS_NAMES.TOTAL_ASSETS, SUMMARY_CARDS_NAMES.CASH_TO_CLOSE],
    addButtonText: 'Asset',
  },
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: {
    title: 'REO',
    summaryCardsNames: [SUMMARY_CARDS_NAMES.REO],
    addButtonText: 'REO',
  },
};

export const CONTENT_DATA = {
  [FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT]: {
    SectionContent: EmploymentAndIncome,
    getDataAction: getBorrowersIncomesAction,
    sendDataAction: updateIncomesAction,
    normalizeReceivedData: normalizeReceivedIncomesData,
    normalizeDataToSend: normalizeIncomesDataToSend,
    normalizePendingChanges: normalizeIncomesPendingChanges,
    tabId: LoanApplicationTabId.INCOME_AND_EMPLOYMENT,
  },
  [FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES]: {
    SectionContent: Liabilities,
    getDataAction: getBorrowersLiabilitiesAction,
    sendDataAction: updateLiabilitiesAction,
    normalizeReceivedData: normalizeLiabilitiesReceivedData,
    normalizeDataToSend: normalizeLiabilitiesDataToSend,
    normalizePendingChanges: normalizeLiabilitiesPendingChanges,
    tabId: LoanApplicationTabId.LIABILITIES,
  },
  [FINANCIAL_INFO_VIEWS_PATHS.ASSETS]: {
    SectionContent: Assets,
    getDataAction: getBorrowersAssetsAction,
    sendDataAction: updateAssetsAction,
    normalizeReceivedData: normalizeAssetsReceivedData,
    normalizeDataToSend: normalizeAssetsDataToSend,
    normalizePendingChanges: normalizeAssetsPendingChanges,
    tabId: LoanApplicationTabId.ASSETS,
  },
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: {
    SectionContent: Reo,
    getDataAction: getBorrowersReoAction,
    sendDataAction: updateReoAction,
    normalizeReceivedData: normalizeReceivedReoData,
    normalizeDataToSend: normalizeReoDataToSend,
    normalizePendingChanges: normalizeReoPendingChanges,
    tabId: LoanApplicationTabId.REO,
  },
};

export const CUSTOM_FIELDS_TARGET_BY_TABLE_PATH = {
  [FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT]: CUSTOM_FIELDS_TARGET.INCOME,
  [FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES]: CUSTOM_FIELDS_TARGET.LIABILITY,
  [FINANCIAL_INFO_VIEWS_PATHS.ASSETS]: CUSTOM_FIELDS_TARGET.ASSET,
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: CUSTOM_FIELDS_TARGET.PROPERTY,
};
